import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8 col-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-column pt-7 ps-4" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "User activity"),
    /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "Overview of user activity")
  ])
], -1)
const _hoisted_3 = {
  key: 1,
  class: "card-body pb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_ActivityTable = _resolveComponent("ActivityTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($setup.data.length == 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "No activity found for viewed user."
              }))
            : (_openBlock(), _createBlock(_component_ActivityTable, {
                key: 1,
                tableData: $setup.data
              }, null, 8, ["tableData"]))
        ])),
    _createVNode(_component_Pagination, {
      class: "pb-2",
      currentPage: $setup.pagination.currentPage,
      totalPages: $setup.pagination.lastPage,
      onChangeCurrentPage: $setup.handlePageChange
    }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
  ]))
}